import Vue from 'vue';
import store from './../../store';
import ediOrderItemTransformer from './../../transformers/ediOrderItem';

const success = ({ data }, resolve) => {
  const ediOrderItems = ediOrderItemTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllEdiOrderItems', ediOrderItems);
  resolve(ediOrderItems);
};

const failed = () => {
};


export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/edi_orders/${id}/edi_order_items`)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrderItem/all.js